import * as React from "react";

const SvgIcnAlignCenter = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <line x1="21" x2="3" y1="6" y2="6" />
        <line x1="17" x2="7" y1="12" y2="12" />
        <line x1="19" x2="5" y1="18" y2="18" />
    </svg>
);
export default SvgIcnAlignCenter;
